/*
 * @Description:外调车运单列表
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2024-06-11 16:22:10
 * @LastEditors: lijinpeng
 */
// 引入api请求方法
import {
  forms,
  pay,
  payType,
  etc,
  oil,
  trajectory,
  extent,
  exception,
} from '@/utils/dictionary/waybillselect';
import {
  getGroups,
  getRouteListByBid,
  getProjectListByBid,
  getChannelInfoList,
  findChannelInfoByCorp,
} from '@/api/common';
import { expiredWaybillWdList, countByStatus } from '@/api/waybill';
import { filterTestCorp } from '@/utils/util';
import { postGroupUserList } from '@/api/enterprise';

const storeModuleName = 'waybillwdModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'select',
      param: 'freightStatusList',
      value: [],
      valueType: 'array',
      state: 'pay',
      label: '支付状态',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
      multiple: true,
    },
    {
      style: 'input-multiple',
      param: 'waybillNos',
      value: '',
      valueType: 'string',
      label: '运单号',
      multiple: true,
      placeholder: '请输入',
      append: '多运单',
      multipleLabel: '运单号',
      multiplePlaceholder:
        '最多可填写50个运单号，需输入完整运单号，运单号中间不能有空格，运单号不换行时请用英文逗号隔开，换行时请每行1个运单号。',
      clearable: true,
    },
    {
      style: 'date-picker',
      param: 'insertTime',
      value: [],
      valueType: 'date',
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['createStartTime', 'createEndTime'],
    },
  ],
  // 特殊筛选项目 带统计信息
  // 页码 + 参数
  postParams: {
    page: 1,
    size: 20,
    orderByCreateTime: false, // 创建时间排序
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '运单',
        prop: 'waybillNo',
        width: 240,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillNo',
      },
      {
        label: '异常提示',
        prop: 'waybillRiskControlDtoList',
        width: 120,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillRiskControlDtoList',
      },
      {
        label: '运单状态',
        prop: 'waybillStatus',
        width: 70,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillStatus',
      },
      {
        label: '装卸货时间',
        prop: 'startTime',
        width: 180,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-startTime',
      },
      {
        label: '司机车辆',
        prop: 'driverName',
        width: 110,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-driverName',
      },
      {
        label: '创建时间',
        prop: 'createTime',
        width: 160,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-createTime',
      },
      {
        label: '运费',
        prop: 'freight',
        width: 720,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-freight',
        slotNameHeader: 'sub-header-freight',
      },
      {
        label: '承运网货',
        prop: 'source',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-source',
      },
      {
        label: '操作',
        width: 130,
        fixed: 'right',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
    ],
  },
  payStatusList: [], // 支付状态统计
  companyList: [], // 企业列表
  channelList: [], // 网络货运平台列表
  companyInfo: '', // 当前选中的企业信息
  projectInfo: '',
  projectList: [], // 项目列表
  routeList: [], // 线路列表
  payPwdExist: '', // 是否设置支付密码
  payPwdStatus: '', // 是否启用支付密码
  forms, // 运单来源
  pay, // 支付状态
  payType, // 运费支付方式
  etc, // ETC
  oil, // 是否分油
  trajectory, // 轨迹
  exception,
  extent, // 载货长度
  filterTestCorp,
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    // 获取统计信息
    if (params.businessId) {
      const { data } = await expiredWaybillWdList(
        Object.assign({}, params, context.state.postParams),
      );
      context.commit('updateState', {
        key: 'listData',
        value: Object.assign({}, context.state.listData, data),
      });
      return data.list;
    }
  },
  // 获取企业列表
  getCompanyList: async (context, payload = 'storage') => {
    let data = JSON.parse(localStorage.getItem('group'));
    if (payload === 'api') {
      const res = await getGroups();
      if (res.code === 200) {
        data = res.data;
        localStorage.setItem('group', JSON.stringify(data));
      }
    }
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 获取网货列表
  getChannelList: async context => {
    const { code, data } = await findChannelInfoByCorp({
      businessId: context.state.parameters[0].value,
      lineType: 'transfer',
    });
    if (code === 200) {
      const list = data.list.filter(item => {
        return item['supportHistory'] * 1 < 2;
      });
      list.forEach(item => {
        item.value = item.id;
        item.label = item.name;
      });
      context.commit('updateState', {
        key: 'channelList',
        value: list,
      });
    }
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams.orderByCreateTime = false;
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        this.dispatch(`${storeModuleName}/getChannelList`);
        break;
      default:
        break;
    }
  },
  // 更新运单号
  updateWaybillNo(state, payload) {
    state.parameters[3].value = payload;
  },
  upmyselfWaybill(state, payload) {
    state.postParams.myselfWaybill = payload;
  },
  upfreightNotSet(state, payload) {
    state.postParams.freightNotSet = payload;
  },
  upotherException(state, payload) {
    state.postParams.otherException = payload;
  },
  uporderByCreateTime(state, payload) {
    state.postParams.orderByCreateTime = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
